<template>
    <v-autocomplete
        hide-no-data
        :search-input.sync="search"
        :items="items"
        :loading="loading"
        return-object
        :clearable="!readonly"
        :value="value"
        v-bind="$props"
        @change="handleOnChange"
        @click:clear="handleOnClear"
        @dblclick="handleDblClick"
        @input="handleInput"
        @keydown.tab="$emit('tab')">
    </v-autocomplete>
</template>

<script>
import { isEmpty } from 'lodash';

export default {
    name: "PSearchInput",
    data() {
        return {
            search: null,
            lastSearch: null,
            loading: false,
            selected: {},
        };
    },
    props: {
        value: [String, Number],
        itemText: { type: String, default: "name" },
        itemValue: { type: String, default: "id" },
        label: { type: String, default: "Search" },
        outlined: Boolean,
        hideDetails: [Boolean, String],
        width: String,
        dense: { type: Boolean, default: true },
        callback: Function,
        getOneCallback: Function,
        resetFunc: Function,
        items: Array,
        action: Function,
        backgroundColor: String,
        disabled: Boolean,
        error: Boolean,
        errorMessages: Array,
        rules: Array,
        singleLine: Boolean,
        readonly: Boolean
    },
    computed: {
        found() {
            if (this.search === null) return this.items;
            return this.items.filter((each) =>
                this.filter(each, this.search, each[this.itemText])
            );
        },
        dirty() {
            return this.lastSearch !== this.search;
        },
    },
    watch: {
        search: {
            handler(search) {
                // empty search
                if (search === null) return;
                // when selected do not fire http.
                if (this.selected[this.itemText] === search) return;
                // has matching record.
                if (this.found.length > 0) return;
                // limit search characters
                if (this.search.trim().length < 2) return;
                // stop firing http if already fired.
                if (this.loading) return;
                // finally call search.
                this.fetchData();
            },
        },
        value: {
            handler() {
                this.fetchOneIfNotExist();
            },
            deep: true
        }
    },
    methods: {
        inStore() {
            let item = this.items.find(each => each.id == this.value);
            return this.items.indexOf(item) !== -1;
        },
        handleInput(val) {
            let value = !isEmpty(val) ? val.id : null;
            this.$emit("input", value);
            this.$emit("input:object", val);
        },
        handleOnChange(val) {
            if (val === null) return;
            this.$emit("change", this.selected);
            this.selected = val[this.itemText];
        },
        handleOnClear() {
            this.selected = {};
            this.$emit('click:clear');
        },
        handleDblClick() {
            if(!this.resetFunc) return;
            this.resetFunc();
            this.$emit("input", null);
        },
        async fetchData() {
            this.loading = true;
            this.lastSearch = this.search;
            let response = await this.callback({ search: this.search, limit: 10 })
            this.action(response.data);
            this.loading = false;
            if (this.dirty) return this.fetchData();
        },
        async fetchOne(val) {
            this.loading = true;
            let response = await this.getOneCallback({id: val});
            if(response.data.record) this.action([response.data.record]);
            else this.action([response.data]);
            this.loading = false;
        },
        fetchOneIfNotExist() {
            // 1. Done not send if val is null
            if(this.value === null) return;
            // 2. If getOneCallback is not provided then return;
            if(!this.getOneCallback) return;
            // 3. Don't do anything if in store.
            if(this.inStore()) return;
            // 4. Fire the request.
            this.fetchOne(this.value);
        },
        filter(item, queryText, itemText) {
            return (
                itemText
                    .toLocaleLowerCase()
                    .indexOf(queryText.toLocaleLowerCase()) > -1
            );
        },
    },
    created() {
        this.fetchOneIfNotExist();
    }
};
</script>
